import React from 'react';
import { GridColumnMenuProps, GridColumnMenuFilter } from '@progress/kendo-react-grid';

const SimpleColumnMenu: React.FC<GridColumnMenuProps> = (props) => {
    return (
        <div>
            <GridColumnMenuFilter {...props} expanded={true} hideSecondFilter={false} />
        </div>
    );
};

export default SimpleColumnMenu;
